/*
 * @Author: 谢云龙
 * @Date: 2024-03-12 16:55:45
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-05-21 11:54:02
 * @Description: 采购汇总明细
 */
import type {
  ISummaryDetailsModel,
  ISummaryDetailsStore,
} from '@monorepo/types/purchasing/summaryDetails/summaryDetails.types';
import { getToday } from '@monorepo/utils';

const initState: ISummaryDetailsStore = {
  isInit: true,
  receiptDetailsList: [],
  storeSummaryList: [],
  purchaseItemsList: [],
  purchaseReturnList: [],
  categorySummaryList: [],
  tableList: [],
  total: 0,
  sum: {},
  query: {
    date_type: 'AUDIT_DATE',
    sort_order: 'REAL_RECEIVED_AT_DESC',
    date: getToday(),
    item_type_id: undefined,
    query_name: '',
    storehouse_num: undefined,
    supplier_id_list: [],
    location_id_list: undefined,
    unit_type: 'USE_UNIT',
    pageSize: 50,
    page: 1,
  },
};

const summaryDetailsStore: ISummaryDetailsModel = {
  namespace: 'summaryDetailsStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default summaryDetailsStore;
